<template>
  <v-card
    height="100%"
  >
    <v-card-title>{{ $t('aff.stats') }}</v-card-title>
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="card"
      :tile="true"
      class="mx-auto"
      width="100%"
    />
    <v-card-text v-if="!$apollo.loading && affStats">
      <v-layout
        wrap
        btc-stats
        mt-4
      >
        <v-flex
          xs12
          md6
        >
          <center>
            <small>{{ $t('aff.btcPersonal') }}</small>
            <p class="text-no-wrap">
              {{ affStats.personal_volume.toFixed(2) | formatMoney }} USDT
            </p>
          </center>
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <center>
            <small>{{ $t('aff.btcStructure') }}</small>
            <p class="text-no-wrap">
              <!-- {{ $t('aff.tempNotAvailable') }} -->
              {{ affStats.structure_volume.toFixed(2) | formatMoney }} USDT
            </p>
          </center>
        </v-flex>
      </v-layout>
      <v-simple-table dense>
        <thead>
          <tr>
            <th />
            <th class="text-left">
              {{ $t('aff.activeUsers') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t('aff.level_one') }}</td>
            <td>{{ affStats.level_one }}</td>
          </tr>
          <tr>
            <td>{{ $t('aff.level_two') }}</td>
            <td>{{ affStats.level_two }}</td>
          </tr>
          <tr>
            <td>{{ $t('aff.level_three') }}</td>
            <td>{{ affStats.level_three }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-text v-if="!$apollo.loading && !affStats">
      <v-flex
        style="margin-top:30px;"
        class="not-found"
      >
        <v-icon>mdi-ghost</v-icon>
        <p>{{ $t('aff.noData') }}</p>
      </v-flex>
    </v-card-text>
    <center v-if="!$apollo.loading">
      <p>
        <small class="text-neutral"><br>
          {{ $t('aff.statsUpdated') }}
          <span
            v-if="affStats"
          > {{ affStats.updated_at | moment('L LTS') }}</span>
          <span v-else>-</span>
        </small>
      </p>
    </center>
  </v-card>
</template>

<script>
import AFFSTATS_QUERY from '@/graphql/queries/AffStats.gql'
export default {
  name: "AffStats",
  data() {
    return {
      loading: false
    };
  },
  apollo: {
    affStats: {
      query: AFFSTATS_QUERY
    }
  }
};
</script>

<style lang="scss">
.btc-stats {
  p {
    font-weight: 600;
    font-size: 15px;
  }
}
</style>